import { Tradable as OldTradable } from "@models/interfaces/tradable";
import { TradableSettings, TradableSettingsAdapter } from "./tradable-settings";
import { TradablePrice, TradablePriceAdapter } from "./tradable-price";
import { TradableInfo, TradableInfoAdapter } from "./tradable-info";
import { TRADABLES_TYPE } from "@helpers/constants";

export interface Tradable {
	readonly id: string;
	readonly pid: string;
	readonly name: string;
	readonly type: TRADABLES_TYPE;
	readonly assetGroupName: string;
	readonly color: string;
	readonly isToken: boolean;
	readonly logo: string;
	readonly logoDark: string;
	readonly defaultLogo: string;
	readonly precisionForCoins: number;
	readonly precisionForFiatPrice: number;
	readonly precisionForTx: number;
	readonly symbol: string;
	readonly displaySymbol: string;
	assetSettings: TradableSettings;
	assetPrice: TradablePrice;
	assetInfo?: TradableInfo;
}

export class TradableAdapter {
	private tradableSettingsAdapter = new TradableSettingsAdapter();
	private tradablePriceAdapter = new TradablePriceAdapter();
	private tradableInfoAdapter = new TradableInfoAdapter();

	public adapt(tradable: OldTradable): Tradable {
		return {
			id: tradable.getId(),
			pid: tradable.getPid(),
			name: tradable.getName(),
			type: tradable.getCurrencyType() as TRADABLES_TYPE,
			assetGroupName: tradable.getAssetGroupName(),
			color: tradable.getColor(),
			isToken: tradable.isToken(),
			logo: tradable.getLogo(),
			logoDark: tradable.getLogoDark(),
			defaultLogo: tradable.getDefaultLogo(),
			precisionForCoins: tradable.getPrecision(),
			precisionForFiatPrice: tradable.getPrecisionFiat(),
			precisionForTx: tradable.getPrecisionForTx(),
			symbol: tradable.getSymbol(),
			displaySymbol: tradable.getSymbol(false, true),
			assetSettings: this.tradableSettingsAdapter.adapt(tradable.getAssetSettings()),
			assetPrice: this.tradablePriceAdapter.adapt(tradable.getAssetPrices()),
			assetInfo: tradable.getAssetInfo() ? this.tradableInfoAdapter.adapt(tradable.getAssetInfo()) : undefined
		};
	}
}
